// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1r9SD","vLegacy":"SelectSecondary_vLegacy__19IDh","error":"SelectSecondary_error__27IER","disabled":"SelectSecondary_disabled__2Guaq"};